const appSyncConfig = {
    aws_appsync_graphqlEndpoint: "https://2wzr4t6275hftppyex3pd72e6a.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    aws_appsync_region: "ap-southeast-2",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
}
export default appSyncConfig;